import { queryKeys } from '@/react-query/constants';
import { createFeatureApi } from '@/shared/api';

/** The spaces feature roots on queryKeys.advertisingSpaces. Filters/availability fold under
 *  keys.sub(...); bookings-for-a-space is NOT here — it lives in features/orders. INTERNAL. */
export const spacesApi = createFeatureApi(queryKeys.advertisingSpaces);
